import React from "react";
import "./StudyInAmerica.css";
import FlagCampusImg from "../Assets/courseform.png";

export default function SectionStudyinamerica() {
  return (
    <div className="siausa-container">
      {/* Left Content */}
      <div className="siausa-content">
        {/* Section 1 */}
        <div className="siausa-section">
          <img src={FlagCampusImg} alt="Campus with flag" className="siausa-image" />
          <h2 className="siausa-title">
           <b>NewZeal Language Academy – The Best English Speaking Course</b>
          </h2>
          <p className="siausa-text">
At NewZeal Language Academy, we believe English is more than just a subject — it’s a skill that can shape your future. Whether you’re a beginner building a foundation, a learner aiming to improve, or someone preparing for global communication, our courses are designed to suit every level.</p>
          <p className="siausa-text">
Our programs cover everything you need to grow:</p>
<ul>
  <li><b>Essential grammar</b> to strengthen your basics</li>
    <li><b>Fluent speaking practice</b> for everyday and professional use</li>
  <li><b>Advanced communication skills</b> to excel globally</li>
  <li><b>Guidance from skilled English tutors</b> every step of the way</li>
</ul>
<p>When you complete a course, you’ll receive a certificate that showcases your achievement — a valuable credential for Employers, Schools and universities and Professional networks</p>
<p>With hands-on practice, group activities, and a supportive learning environment, you’ll gain the confidence to communicate in English with clarity and ease.</p>
        </div>
      </div>

      {/* Right Form */}
    </div>
  );
}
